import styled from 'react-emotion';
import { theme } from '@ublend-npm/aulaui-next';
import UnstyledVisibilityOnIcon from '@mui/icons-material/Visibility';

export const TitleContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${theme.spacing.medium};

  span.material-section-title-disabled {
    color: ${theme.color.designSystem.blackOpacity87};
  }
`;

export const PreviewBanner = styled('span')`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
`;

export const AlertStyledContainer = styled('div')`
  background-color: #e5f6fd;
  border-radius: 8px;
  padding: 12.5px 20px;
  display: flex;
  justify-content: space-between;
  align-items: start;
`;

export const TitleContainerCenter = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.small};
`;
